import { fetchPost, fetchPut, fetchGet, fetchDelete, rootApi } from '../helpers/api';

const personaApi = `${rootApi}/personas`;

export const create = persona => fetchPost(personaApi, persona);

export const update = persona => fetchPut(personaApi, persona);

export const _delete = personaId => fetchDelete(`${personaApi}/${personaId}`);

export const fetchAll = () => fetchGet(personaApi)